import crud from '@/crud/form/form'
import resources from '../../resources'
import methods from './methods'

export default {
  methods,

  resourcePath: 'v1/patient/settings/addresses',
  mixins: [crud, resources]
}



// WEBPACK FOOTER //
// ./src/app/settings/addresses/form/resources/index.js